/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_TestingInputs */

const vi_einvoice_credential_testing = /** @type {(inputs: Einvoice_Credential_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kiểm tra kết nối…`)
};

/**

* @param {Einvoice_Credential_TestingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_testing = /** @type {((inputs?: Einvoice_Credential_TestingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_TestingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_testing(inputs)
});